define('IEBugFixes',['jquery', 'StickyKit'], function ($) {
    "use strict";
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');

    if ( msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) ) {
        $('body').addClass('brows-ie');
        if ( $('.ansi-header').length ) {
            $('.ansi-header').stick_in_parent({ offset_top: 0 });
        }
        if ( $('.ansi-sticky-navbar').length ) {
            $('.ansi-header.pull-up').stick_in_parent({ offset_top: -72 });
            $('.ansi-sticky-navbar.sticky').stick_in_parent({ offset_top: 0 });
        }
    }
});
